<div class="sticky-top">
  <app-back-to-top></app-back-to-top>
</div>
<div>
  <!-- Div to make sticky-top work on ios -->
  <app-static-container headerImage="6" [capsuleConseilTexte]="'acte-vente.capsule-description' | translate">
    <h1 appFocusOnInit class="titre-page" id="titre-page">{{ 'acte-vente.header' | translate }}</h1>
    <h2 class="titre-section">{{ 'acte-vente.titre' | translate }}</h2>
    <section class="text-content">
      <div class="paragraph-group">
        <p>{{ 'acte-vente.content-1.texte' | translate }}</p>
        <h3 class="subsection">{{ 'acte-vente.content-2.titre' | translate }}</h3>
        <div class="paragraph">
          <p class="paragraph-xs">{{ 'acte-vente.content-2.texte-1' | translate }}</p>
          <p>{{ 'acte-vente.content-2.texte-2' | translate }}</p>
        </div>
        <ul>
          <li>{{ 'acte-vente.content-2.point-1' | translate }}</li>
          <li>{{ 'acte-vente.content-2.point-2' | translate }}</li>
          <li>
            {{ 'acte-vente.content-2.point-3' | translate }}
            <a
              tabindex="0"
              class="link"
              id="btn-assurance"
              *featureToggle="MPM_ASSURANCE_SOUMISSION.DAG"
              (click)="onClickInsuranceInquiry()"
              (keydown.enter)="onClickInsuranceInquiry()"
            >
              {{ 'acte-vente.content-2.point-3.1' | translate }}
              <span class="sr-only">{{ 'acte-vente.content-2.point-3.1-sr' | translate }}</span>
            </a>
          </li>
          <li>{{ 'acte-vente.content-2.point-4' | translate }}</li>
          <li>{{ 'acte-vente.content-2.point-5' | translate }}</li>
        </ul>

        <h3 class="subsection">{{ 'acte-vente.content-3.titre' | translate }}</h3>
        <ul>
          <li>{{ 'acte-vente.content-3.point-1' | translate }}</li>
          <li>{{ 'acte-vente.content-3.point-2' | translate }}</li>
        </ul>

        <h3 class="subsection">{{ 'acte-vente.content-4.titre' | translate }}</h3>
        <ul class="paragraph">
          <li>{{ 'acte-vente.content-4.point-1' | translate }}</li>
          <li>{{ 'acte-vente.content-4.point-2' | translate }}</li>
          <li>{{ 'acte-vente.content-4.point-3' | translate }}</li>
          <li>{{ 'acte-vente.content-4.point-4' | translate }}</li>
          <li>{{ 'acte-vente.content-4.point-5' | translate }}</li>
        </ul>
        <p class="paragraph">
          {{ 'acte-vente.content-4.texte' | translate }}
        </p>
      </div>
    </section>
  </app-static-container>
  <app-sub-footer [enableNextStep]="true" [nextStep]="'emmenagement'"></app-sub-footer>
</div>
